
/// <reference path="../../../setup/_references.ts" />
module onvio.clientDashboard.ClientCommentsComponent {
    'use strict';

    export interface IClientCommentsComponentScope extends ng.IScope {
        isInAddMode: boolean;
        isInEditMode: boolean;
        noteToEdit: any;
        note: any;
        isDisabled: boolean;
        update: (note: any) => any;
        done: () => void;
        entityId: string;
        isLoaderBusy: boolean;
        notes: any;
    }

    export class ClientCommentsController {
        public entityId: string;
        public entityName: string;
        public client: cs.IClientWithExpansionV3Dto;

        static $inject = [
            '$rootScope',
            '$scope',
            'bmnNoteService'
        ];
        constructor(
            private $rootScope: ng.IRootScopeService,
            private $scope: IClientCommentsComponentScope,
            private noteService: any
        ) {
            let self = this;
            this.$scope.isLoaderBusy = false;
            this.$scope.isInAddMode = false;
            this.$scope.isInEditMode = false;
            this.$scope.noteToEdit = {};
            this.$scope.isDisabled = false;

            if (this.client) {
                this.$scope.note = {
                    type: 'general',
                    entity: {
                        id: this.client.primaryContact.id,
                        name: this.client.name,
                          icon: ''
                    }
                };
                this.loadNotes();
            }

            this.$scope.$on('enteringAddMode', function() {
                self.$scope.$broadcast('parentEnteringAddMode', null);
                self.$scope.isInAddMode = true;
            });

            this.$scope.$on('leavingAddMode', function() {
                self.$scope.$broadcast('parentLeavingAddMode', null);
                self.$scope.isInAddMode = false;
            });

            this.$scope.$on('enteringEditMode', function(event, note) {
                self.$scope.noteToEdit = note;
                self.$scope.$broadcast('parentEnteringEditMode', note);
                self.$scope.isInEditMode = true;
            });

            this.$scope.$on('turnOnBusyLoader', function() {
                self.$scope.isLoaderBusy = true;
            });

            this.$scope.$on('turnOffBusyLoader', function() {
                self.$scope.isLoaderBusy = false;
            });

            this.$scope.$on('leavingEditMode', function(event, note) {
                self.leaveEditMode(note);
            });

            this.$scope.update = function(note: any) {
                if (note !== null) {
                    for (var i = 0; i < self.$scope.notes.length; i++) {
                        if (self.$scope.notes[i].id === note.id) {
                            self.$scope.notes[i] = note;
                        }
                    }
                    self.leaveEditMode(note);
                }
            };

            var unlistenBmnNoteDeleted = this.$rootScope.$on('bmnNoteDeleted', function(event, note) {
                var index = self.$scope.notes.indexOf(note);
                if (index > -1) {
                    self.$scope.notes.splice(index, 1);
                }
                self.leaveEditMode(note);
            });

            var unlistenBmnNoteAdded = $rootScope.$on('bmnNoteAdded', function(event, note) {
                self.$scope.notes.push(note);
            });

            this.$scope.$on('$destroy', function() {
                unlistenBmnNoteAdded();
                unlistenBmnNoteDeleted();
            });
        }

        $onChanges(changes: any) {
            if (changes.client && changes.client.currentValue && changes.client.currentValue.id) {
                this.$scope.notes = [];
                this.$scope.note = {
                    type: 'general',
                    entity: {
                        id: changes.client.currentValue.primaryContact.id,
                        name: changes.client.currentValue.name,
                          icon: ''
                    }
                };
                this.loadNotes();
            }
        }

        public loadNotes(): any {
            let self = this;
            this.$scope.isLoaderBusy = true;

            this.noteService.getNotes(this.$scope.note.entity.id).then(function(requestResult: any) {
                self.$scope.isLoaderBusy = false;
                if (requestResult.result === 'success') {
                    self.$scope.notes = requestResult.data;
                }
            });
        }

        public leaveEditMode(note: any): void {
            this.$scope.noteToEdit = {};
            this.$scope.$broadcast('parentLeavingEditMode', null);
            this.$scope.isInEditMode = false;
        }
    }

    export class ClientCommentsComponent implements ng.IComponentOptions {
        bindings: any = {
            client: '<'
        };
        controller = ClientCommentsController;
        templateUrl = 'client-dashboard/components/client-comments-component/client-comments-component.html';
    }

    angular.module('onvio.clientDashboard.ClientCommentsComponent', [])
        .component('clientCommentsComponent', new ClientCommentsComponent());
}
